module.exports = __webpack_public_path__ + "static/media/laptop.eb0ed936.png";